import { useNavigate } from 'react-router-dom';
import { AdminContentCollectionEditor } from '../../../components/AdminContentCollectionEditor';
import AdminPage from '../../../components/AdminPage';

const ContentCollectionNew = () => {
  const navigate = useNavigate();

  const onSuccess = (response) => {
    navigate(`/content/collections/${response.data.id}`);
  };

  const onFailure = (data) => {
    console.error(data);
  };

  return (
    <>
      <AdminPage showSidebar={true} title={'Create Collection'}>
        <AdminContentCollectionEditor
          onSuccess={onSuccess}
          onFailure={onFailure}
        />
      </AdminPage>
    </>
  );
};

export default ContentCollectionNew;
